import {
  AppLink,
  useAppNavigate,
  useAppLocation,
  useAnalytics,
  makeUrl } from
"@commons-monorepo/index";
import { MainHeaderSideMenuProps } from "../../main-header-sidebar-menu.types";
import styles from "./sidebar-menu-1.module.css";
import { MainSidebarMenuEvents } from "../../main-header-sidebar-menu.events";
import { useTranslation } from "react-i18next";

export const MainHeaderSideMenu1 = ({
  onClose,
  hasServices,
  theme,
  storeMetadata
}: MainHeaderSideMenuProps) => {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const { pathname } = useAppLocation();
  const dataAboutUs = storeMetadata?.catalogueAboutUs;
  const [logEvent] = useAnalytics({ storeMetadata });

  return (
    <aside className={styles.wrapper}>
      <div className='overlay' onClick={() => onClose()} />
      <div className='modal'>
        <div className='modal-head'>
          <div className='close' onClick={() => onClose()}>
            <span className='icon-close' />
          </div>
        </div>
        <div className='modal-content'>
          <div
            className='modal-content-item'
            onClick={() => {
              onClose();
              navigate(
                `${pathname}/${makeUrl(
                  pathname,
                  `${pathname}/iniciar-sesion`
                )}`,
                { relative: "path" }
              );
            }}>

            <span className={"icon-user icon"} />
            <p>{t("main_header.sign_in")}</p>
          </div>
          <div
            className='modal-content-item'
            onClick={() => {
              onClose();
              navigate(
                `${pathname}/${makeUrl(pathname, `${pathname}/contactanos`)}`,
                { relative: "path" }
              );
            }}>

            <span className='icon-info-alert-icon icon' />
            <p>{t("main_header.store_information")}</p>
          </div>
          {dataAboutUs &&
          <div
            className='modal-content-item'
            onClick={() => {
              onClose();
              navigate(`${pathname}/${makeUrl(pathname, `sobre-nosotros`)}`);
              logEvent(MainSidebarMenuEvents.SelectMenuContactAboutUs, {
                Template_id: theme.templateId
              });
            }}>

              <span className='icon-store icon' />
              <p>{t("main_header.about")}</p>
            </div>}

          {hasServices &&
          <AppLink
            to={`${pathname}/${makeUrl(pathname, "servicios")}`}
            onClick={() => {
              onClose();
            }}
            className='modal-content-item'>

              <span className='icon-store icon' />
              {t("main_header.services")}
            </AppLink>}

        </div>
      </div>
    </aside>);

};